// extracted by mini-css-extract-plugin
export default {"warning-message__icon":"warning-message__icon_S0qF2Unm"};